'use strict';

var React = require('react');

var SvgMetafieldsFilledMinor = function SvgMetafieldsFilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.25a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.25h3v-1.25a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.25h1a1 1 0 0 1 1 1v6a.5.5 0 0 1-.5.5h-14a.5.5 0 0 1-.5-.5v-6a1 1 0 0 1 1-1h1v-1.25z"
  }));
};
SvgMetafieldsFilledMinor.displayName = "MetafieldsFilledMinor";

exports.SvgMetafieldsFilledMinor = SvgMetafieldsFilledMinor;
